var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temLinhas
    ? _c(
        "div",
        _vm._b(
          {
            staticClass: "relatorio-do-lote ia-block-card",
            attrs: { "data-test": "relatorio-do-lote" }
          },
          "div",
          _vm.MOLDURA_DO_THREAD,
          false
        ),
        [
          _c(
            "button",
            {
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--fita ia-block-card__cabecalho--clicavel",
              attrs: {
                type: "button",
                "aria-expanded": String(_vm.aberto),
                "aria-label": _vm.RELATORIO_DO_LOTE.ARIA_LISTA,
                "data-test": "relatorio-do-lote-cabecalho"
              },
              on: { click: _vm.alternar }
            },
            [
              _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: { name: "task", size: 14, color: "var(--primary)" }
              }),
              _c("span", { staticClass: "ia-block-card__titulo" }, [
                _vm._v(_vm._s(_vm.RELATORIO_DO_LOTE.TITULO))
              ]),
              _c("span", { staticClass: "ia-block-card__meta" }, [
                _vm._v(_vm._s(_vm.resumo))
              ]),
              _c("icon-svg", {
                staticClass: "ia-block-seta",
                class: _vm.classeSeta,
                attrs: {
                  name: "arrow-down-new-ux",
                  size: 14,
                  color: "var(--neutral-700)"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.aberto,
                  expression: "aberto"
                }
              ],
              staticClass: "relatorio-do-lote__corpo"
            },
            [
              _vm._l(_vm.itens, function(item) {
                return _c(
                  "div",
                  {
                    key: item.chave,
                    staticClass: "relatorio-do-lote__item",
                    attrs: { "data-test": "relatorio-do-lote-item" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "relatorio-do-lote__linha" },
                      [
                        _c("icon-svg", {
                          attrs: { name: item.icone, size: 14, color: item.cor }
                        }),
                        _c(
                          "span",
                          {
                            staticClass:
                              "relatorio-do-lote__acao ia-texto-auxiliar"
                          },
                          [_vm._v(_vm._s(item.resumo))]
                        ),
                        _c("BaseStatus", {
                          attrs: {
                            text: "",
                            color: item.cor,
                            content: item.rotulo,
                            "preserve-case": ""
                          }
                        })
                      ],
                      1
                    ),
                    item.detalhe
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "relatorio-do-lote__detalhe ia-texto-auxiliar"
                          },
                          [_vm._v(" " + _vm._s(item.detalhe) + " ")]
                        )
                      : _vm._e()
                  ]
                )
              }),
              _c(
                "p",
                { staticClass: "relatorio-do-lote__nota ia-texto-auxiliar" },
                [_vm._v(_vm._s(_vm.RELATORIO_DO_LOTE.SO_NESTA_SESSAO))]
              )
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }